import React, { useState, setState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";

/*BootstrapTable anbd table Related*/
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import InputSelect from "../../common/InputSelect";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";

/*Other Components*/
import Sports from "../../common/Sports";
import Periods from "../../common/Periods";

/*Loader */
import FadeIn from "react-fade-in";
import ReactLoading from "react-loading";

/*Inputs*/
/*Styles*/
import "./WagerLimitsSettings.css";

import WagerTypes from "../../common/WagerTypes";
import GameTypes from "../../common/GameTypes";
import WagerLimitsDetails from "./WagerLimitsDetails";
import { FormControl } from "@material-ui/core";

export default function ProfileSettings(props) {
  const [gameType, setGameType] = React.useState(1);
  const [online, setOnline] = React.useState(0);

  let idProfile = props.WagerLimit.idProfileLimits;

  const handleOnlineChange = (event) => {
    setOnline(Number(event.target.value));
  };

  const setGameTypeOnMem = (idGameType) => {
    setGameType(idGameType);
  };

  return (
    <div className="flex flex-row gap-4">
      <div className="min-w-[230px]">
        <GameTypes
          isEasy={true}
          style={{ marginTop: -250 }}
          setGameTypeOnMem={setGameTypeOnMem}
        ></GameTypes>
      </div>
      <div className="flex flex-col flex-1 gap-4 h-max">
        <div className="!gap-0 vertical-options">
          <FormControl component="fieldset" >
            <RadioGroup
              row
              label
              value={online}
              onChange={(event) => {
                handleOnlineChange(event);
              }}
            >
              <FormControlLabel
                control={<Radio value={0} size="small" color="primary" />}
                label="Local"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={1} size="small" color="primary" />}
                label="Online"
                labelPlacement="end"
              />
            </RadioGroup>
          </FormControl>
        </div>
        <WagerLimitsDetails
          IdProfileLimits={idProfile}
          IdGameType={gameType}
          Online={online}
        />
      </div>
    </div>
  );
}
